import LocalStorageService from '../features/common/local-storage-service';
import { ClaimTypes } from '../constants/claim-types';
import jwtDecode from 'jwt-decode';
export const getCurrentUserFromJwt = (token) => {
    const authToken = token || LocalStorageService.getAccessToken();
    if (authToken != null) {
        const decodedJWT = jwtDecode(authToken);
        const currentUser = {
            accessToken: authToken,
            id: decodedJWT[ClaimTypes.NameIdentifier],
            name: decodedJWT[ClaimTypes.Name],
            role: decodedJWT[ClaimTypes.Role],
            email: decodedJWT[ClaimTypes.Email]
            //country: JSON.parse(decodedJWT[ClaimTypes.Country])
        };
        return currentUser;
    }
};
